import React from 'react';
import './Contactus.css';
import Mapp from '../assets/mapp.png';
import { Form } from "react-bootstrap";
import Nail2 from '../assets/nail2.jpg';
const Contactus = () => {
  return (
    <>
    <div className='' style={{background:'white'}}>

   <div style={{ position: "relative" }}>
  <h2 className="text-center contactus">Contact Us</h2>
  <img
    src={Mapp}
    className="mapimag mt-2"
    style={{ width: "100%", height: "75vh", objectFit: "cover" }}
  />
  <div className="location">
    <svg width="75" height="65" viewBox="0 0 75 85" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M74.375 35.4167C74.375 60.2084 42.5 81.4584 42.5 81.4584C42.5 81.4584 10.625 60.2084 10.625 35.4167C10.625 26.9629 13.9832 18.8554 19.961 12.8777C25.9387 6.89994 34.0462 3.54169 42.5 3.54169C50.9538 3.54169 59.0613 6.89994 65.039 12.8777C71.0168 18.8554 74.375 26.9629 74.375 35.4167Z"
        fill="#6B0606"
      />
      <path
        d="M42.5 46.0417C48.368 46.0417 53.125 41.2847 53.125 35.4167C53.125 29.5487 48.368 24.7917 42.5 24.7917C36.632 24.7917 31.875 29.5487 31.875 35.4167C31.875 41.2847 36.632 46.0417 42.5 46.0417Z"
        fill="white"
      />
    </svg>
  </div>
</div>

    <div className="container py- text-center ">
  <div className="d-flex justify-content-center p-5">
    <table className="table table-borderless table-sm text-dark">
      <thead>
        <tr>
          <th className="contableheader w-25">Address</th>
          <th className="contableheader w-25">Email</th>
          <th className="contableheader w-25">Phone</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="contacttable pt-4 " >719 Avenue U <br/>Brooklyn, NY 11223</td>
          <td className="contacttable pt-4">medina@frontiersgi.com</td>
          <td className="contacttable pt-4">+1 920-920-0707</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</div>

<div className='half-bg-top'>
<div className="container-fluid d-flex justify-content-center align-items-center py-5 pb-5">
      <div className="row shadow-lg p-3 d-flex flex-wrap rounded-3 " style={{ maxWidth: "800px", backgroundColor: "#fff" }}>
        
        {/* Left Side Image */}
        <div className="col-lg-4 col-md-5 col-12 d-flex justify-content-center align-items-center p-3">
          <img
            src={Nail2}
            alt="Appointment"
            className="img-fluid rounded"
            style={{ height: "70vh", maxWidth: "100%", borderRadius: "15px" }}
          />
        </div>

        {/* Right Side Form */}
        <div className="col-lg-8 col-md-7 col-12 p-4">
          <h3 className="text-start bookappoinment">Book Appointment</h3>
          <p className="text-muted text-start bookingsubhead">
            Mi senectus ac ullamcorper sollicitudin volutpat sit a velit. Purus scelerisque
          </p>

          <Form className="p-0">
            <div className="row mb-2">
              <div className="col-12 col-sm-6">
                <Form.Label className="mb-1 formlabel">First Name</Form.Label>
                <Form.Control type="text" className="form-control inputflds" placeholder="First Name" required />
              </div>
              <div className="col-12 col-sm-6">
                <Form.Label className="mb-1 formlabel">Last Name</Form.Label>
                <Form.Control type="text" className="form-control inputflds" placeholder="Last Name" required />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-12 col-sm-6">
                <Form.Label className="mb-1 formlabel">Email</Form.Label>
                <Form.Control type="email" className="form-control inputflds" placeholder="Email" required />
              </div>
              <div className="col-12 col-sm-6">
                <Form.Label className="mb-1 formlabel">Phone</Form.Label>
                <Form.Control type="tel" className="form-control inputflds" placeholder="Phone Number" required />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-12 col-sm-6">
                <Form.Label className="mb-1 formlabel">Date</Form.Label>
                <Form.Control type="date"  className="form-control inputflds" required />
              </div>
              <div className="col-12 col-sm-6">
                <Form.Label className="mb-1 formlabel">Time</Form.Label>
                <Form.Control type="time"  className="form-control inputflds" required />
              </div>
            </div>

            <div className="mb-3">
              <Form.Label className="mb-1 formlabel">Services</Form.Label>
              <Form.Select required className="form-control inputflds">
                <option className="selects">Service</option>
                <option className="selects">Russian Manicure</option>
                <option className="selects">Luxury Pedicure</option>
                <option className="selects">Nail Art</option>
              </Form.Select>
            </div>

            {/* Button */}
            <div className="text-center">
              <button className="sendmessagebtn d-flex align-items-center justify-content-center">
                <span>Book Now</span>
                <span className="ms-1 pt-1">
                  <i className="bi bi-arrow-right-short"></i>
                </span>
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>

    </div>
    
    </>
  )
}
export default Contactus;